import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import DashboardBadge from "../DashboardBadge";
import DashboardPreviewInfo from "../DashboardPreviewInfo";

function BotPerformancePreview() {
  const {
    dashboard: { botInfo, botInfoStatus },
  } = useSelector((state) => state);

  const { collapsed_preview: { badge_text, summary_text } = {} } = botInfo;

  return (
    <>
      {botInfoStatus === "loading" && (
        <>
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </>
      )}

      {botInfoStatus === "success" && (
        <>
          <DashboardBadge type="primary">{badge_text}</DashboardBadge>
          <DashboardPreviewInfo>{summary_text}</DashboardPreviewInfo>
        </>
      )}
    </>
  );
}

export default BotPerformancePreview;
